<div style="width: 100%">
  <p-multiSelect
    [options]="channels"
    [(ngModel)]="selectedChannels"
    (change)="onChannelsSelect()"
    [filter]="false"
    optionLabel="name"
    [displaySelectedLabel]="false"
    [defaultLabel]="'Canal'"
    [style]="{ width: '100%' }"
    class="custom-multiselect"
  ></p-multiSelect>
</div>
